/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBackUp = createReactComponent("outline", "arrow-back-up", "IconArrowBackUp", [["path", { "d": "M9 14l-4 -4l4 -4", "key": "svg-0" }], ["path", { "d": "M5 10h11a4 4 0 1 1 0 8h-1", "key": "svg-1" }]]);

export { IconArrowBackUp as default };
//# sourceMappingURL=IconArrowBackUp.mjs.map
